import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment'
import CONSTANT from './../../../constant';
import Header from '../../../component/common/LeaveHeader';

import { getHolidayList, updateHoliday } from '../../../actions/MasterAction';
import { onChange, validateForm, getDateParts } from './../../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            name: { name: 'name', value: '', error: '', isRequired: true },
            date: { name: 'date', value: new Date().toISOString().split('T')[0], error: '', isRequired: true },
            page: 1,
            limit: 10,
            list: undefined,
            tableIndex: 0
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { page, name, date, list, tableIndex } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Holiday(s)</h1>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <Link to={CONSTANT.component.adminAddHoliday.url} className="btn btn-sm submit-button">
                                    <i className="fa fa-plus-circle mr-2" />
                                    Add Holiday
                                </Link>
                            </div>
                            <div className="col-md-6">
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Dated</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Unit</th>
                                                <th scope="col">Modified by</th>
                                                <th scope="col">Modified on</th>
                                                <th></th>
                                            </tr>
                                            {
                                                list === undefined && <tr>
                                                    <td colSpan={7} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.length === 0 && <tr>
                                                    <td colSpan={7} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.adminEditHoliday.url.replace(':code', item.code);
                                                    const dt = getDateParts(item.modifiedOn);
                                                    return (
                                                        <tr className="c-pointer" key={index + 1} onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{moment(item.date).format("MMM Do YYYY")}</td>
                                                            <td >{item.name}</td>
                                                            <td >{item.unitName ? item.unitName : '-'}</td>
                                                            <td >{item.modifiedByName}</td>
                                                            <td >{`${dt.date} ${dt.monthName} ${dt.year} ${dt.hour}:${dt.minute} ${dt.amOrpm}`}</td>
                                                            <td><i className="fa fa-pencil" /></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    windowModel = (el: any) => {

    }
    loadList = () => {
        getHolidayList().then((res: any) => {
            if (res)
                this.setState({ list: res.result });
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }

    changePage = (e: any) => {
        const type = e.target.dataset.type;
        const page = type === '+' ? this.state.page + 1 : this.state.page - 1;
        this.setState({ page }, () => { this.loadList() });
    }

    onChange = (e: any) => {
        onChange(this, e.target.name, e.target.value);
    }

    onEdit = (index: any, name: any, date: any) => {
        this.setState({ tableIndex: index })
        onChange(this, 'name', name);
        onChange(this, 'date', new Date(date).toISOString().split('T')[0]);

    }
}

export default ComponentName;